import React from 'react';
import '../../assets/css/case-property.css';

interface PropertyContentSectionProps {
  variant: 'dark' | 'light';
  /** Swap column order (images first on desktop) */
  reverse?: boolean;
  left: React.ReactNode;
  right: React.ReactNode;
  className?: string;
  /** Optional decorative overlay rendered behind content */
  overlay?: React.ReactNode;
}

/**
 * Shared two-column section layout used across property interior pages.
 * Alternates dark/light backgrounds. Reuses .prop-al-content-cols CSS.
 */
export function PropertyContentSection({ variant, reverse, left, right, className, overlay }: PropertyContentSectionProps) {
  const bgClass = variant === 'dark' ? 'prop-al-bg-dark' : 'prop-al-bg-light';

  return (
    <section className={`prop-al-content-cols ${bgClass}${className ? ` ${className}` : ''}`}>
      {overlay}
      <div className="prop-al-container-main">
        <div className={`prop-al-cols-row${reverse ? ' reverse' : ''}`}>
          <div className="prop-al-col">{left}</div>
          <div className="prop-al-col">{right}</div>
        </div>
      </div>
    </section>
  );
}

export default PropertyContentSection;
